import { graphql } from '@/gql';
import type { CreatePartnerGeofenceMutationVariables, CreatePartnerGeofenceMutation } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export { PartnerGeofenceTarget } from '@/gql/graphql';

export type CreatePartnerGeofenceInput = CreatePartnerGeofenceMutationVariables['data'];

export type CreatePartnerGeofenceOutput = CreatePartnerGeofenceMutation['createPartnerGeofence'];

export const createPartnerGeofence = async (data: CreatePartnerGeofenceInput): Promise<CreatePartnerGeofenceOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreatePartnerGeofence($data: PartnerGeofenceInputType!) {
        createPartnerGeofence(data: $data) {
          id
          partnerId
          code
          data
          target
          centroid {
            lat
            lng
          }
          polygons {
            lat
            lng
          }
        }
      }
    `),
    variables: {
      data,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data!.createPartnerGeofence;
};
